import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import facebookIcon from '../assets/facbook-icon.svg'
import hmrcBadge from '../assets/hmrc.jpeg'
import instagramIcon from '../assets/instagram-icon.svg'
import linkedinIcon from '../assets/linkedin.svg'
import whiteLogo from '../assets/white-brit-logo.svg'

export default function Footer() {
  const navigate = useNavigate()
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  const faqs = [
    {
      id: 1,
      question: 'What is BritFiler?',
      answer: 'BritFiler is a one-stop platform to file Corporation Tax, Self Assessment, Annual Accounts, and Confirmation Statements — all in one place.',
    },
    {
      id: 2,
      question: 'Is BritFiler secure?',
      answer: 'Yes, BritFiler is recognized by HMRC and fully integrated with their systems, using secure APIs to ensure compliance with all UK regulations.',
    },
    {
      id: 3,
      question: 'Is BritFiler free to use?',
      answer: 'BritFiler offers flexible pricing plans to suit different needs, with options for one-time filings and subscription plans.',
    },
  ]

  const toggleFaq = (id: number) => {
    setOpenFaq(openFaq === id ? null : id)
  }
  return (
    <footer className='bg-[#1A1E20] text-white py-16'>
      <div className='w-full mx-auto px-4 sm:px-6 lg:px-20'>
        {/* Main Footer Content */}
        <div className='flex flex-col md:flex-row items-center md:items-start justify-between w-full gap-8 md:gap-4 mb-8 md:mb-0'>
          {/* Left Section - Logo and Tagline */}
          <div className='flex flex-col items-center md:items-start justify-center'>
            <img src={whiteLogo} alt='BritFiler Logo' className='h-8 mb-4' />
            <p className='text-gray-300 text-sm leading-relaxed max-w-xs text-center md:text-left'>
            Simplify your tax and company filings today.
Start now and see why BritFiler is the easiest way to stay compliant with HMRC and Companies House.
Get Started for Free
            </p>
          </div>

          {/* Contact Information */}
          <div className='space-y-6 text-center md:text-left'>
            <div>
              <h4 className='text-gray-400 text-sm font-medium mb-2'>
                Address
              </h4>
              <p className='text-white text-sm'>
                BRITFILER LTD
                <br />
                Office 1, Izabella House
                <br />
                24-26 Regent Place, City Centre
                <br />
                Birmingham
                <br />
                United Kingdom
                <br />
                B1 3NJ
              </p>
            </div>
          </div>

          {/* Contact Details */}
          <div className='text-center md:text-left'>
            <div className='space-y-6'>
              <div>
                <h4 className='text-gray-400 text-sm font-medium mb-2'>
                  Phone
                </h4>
                <p className='text-white text-sm'>+447469968984</p>
              </div>
              <div>
                <h4 className='text-gray-400 text-sm font-medium mb-2'>
                  Email
                </h4>
                <p className='text-white text-sm'>info@britfiler.co.uk</p>
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between w-full gap-8 lg:gap-4 mt-8'>
          {/* Newsletter Signup */}
          <div className='mb-8 lg:mb-12 w-full lg:w-auto'>
            <h3 className='text-white text-lg md:text-xl font-semibold mb-4 text-start'>
              Ready to get started ?
            </h3>
            <p className='text-gray-300 text-sm mb-6 leading-relaxed max-w-md text-start'>
              If there are questions you want to ask, we will answer all your
              question
            </p>
            <div className='flex flex-col sm:flex-row gap-4 sm:gap-0'>
              <input
                type='email'
                placeholder='Enter your email'
                className='flex-1 bg-transparent border-b border-gray-600 text-white placeholder-gray-400 py-2 px-0 focus:outline-none focus:border-red-500 text-sm min-w-0'
              />
              <button 
                onClick={() => navigate('/sign-up')}
                className='bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-full text-sm font-medium sm:ml-4 transition-colors w-full sm:w-auto cursor-pointer'
              >
                Join now
              </button>
            </div>
          </div>
          {/* FAQ Section */}
          <div className='w-full lg:w-auto'>
            <h4 className='text-white text-base md:text-lg font-medium mb-6'>
              Maybe your question hasn't been answered, check this out.
            </h4>
            <div className='space-y-4'>
              {faqs.map((faq) => (
                <div key={faq.id} className='border-b border-gray-700'>
                  <button
                    onClick={() => toggleFaq(faq.id)}
                    className='w-full flex items-center justify-between py-3 text-left hover:text-gray-200 transition-colors'
                  >
                    <span className='text-white text-sm'>{faq.question}</span>
                    <svg
                      className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${
                        openFaq === faq.id ? 'rotate-90' : ''
                      }`}
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth={2}
                        d='M9 5l7 7-7 7'
                      />
                    </svg>
                  </button>
                  {openFaq === faq.id && (
                    <div className='pb-3 pl-0'>
                      <p className='text-gray-300 text-sm leading-relaxed'>
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* HMRC Recognised badge */}
        <div className='mt-10 flex justify-center md:justify-start'>
          <div className='inline-flex items-center gap-3 rounded-full bg-white/95 px-4 py-2'>
            <img
              src={hmrcBadge}
              alt='HMRC Recognised for Corporation Tax Filing'
              className='h-10 w-auto'
            />
            <span className='text-xs font-semibold text-[#181D27]'>
              HMRC Recognised
            </span>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='border-t border-gray-700 mt-8 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            {/* Social Media Icons */}
            <div className='flex items-center space-x-4'>
              <a
                href='https://www.facebook.com/share/1E998vstvR/?mibextid=wwXIfr'
                target='_blank'
                rel='noopener noreferrer'
                className='text-gray-400 hover:text-white transition-colors'
              >
                <img src={facebookIcon} alt='Facebook' className='w-5 h-5' />
              </a>
              <button className='text-gray-400 hover:text-white transition-colors'>
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path d='M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z' />
                </svg>
              </button>
              <a
                href='https://www.instagram.com/britfiler?utm_source=qr'
                target='_blank'
                rel='noopener noreferrer'
                className='text-gray-400 hover:text-white transition-colors'
              >
                <img src={instagramIcon} alt='Instagram' className='w-5 h-5' />
              </a>
              <button className='text-gray-400 hover:text-white transition-colors'>
                <img src={linkedinIcon} alt='LinkedIn' className='w-5 h-5' />
              </button>
            </div>

            {/* Footer Links */}
            <div className='flex items-center  text-sm'>
              <Link
                to='/terms'
                className='text-gray-400 hover:text-white transition-colors'
              >
                Privacy Policy
              </Link>
            </div>

            {/* Copyright */}
            <div className='text-gray-400 text-sm'>
              © Copyright 2026 All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
